// Format a number of seconds as `m:ss` (e.g. 65 → "1:05"). Negative input clamps to 0:00.
export const formatTimestamp = (seconds: number): string => {
  const s = Math.max(0, Math.floor(seconds));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
};

// Render transcript lines as `[m:ss]  text`, one per line — used for copy + download.
export const toPlainText = (lines: { startTime: number; text: string }[]): string =>
  lines.map((l) => `[${formatTimestamp(l.startTime)}]  ${l.text}`).join('\n');
